import React from 'react'

const SiteHead = props=> (
        <div className="site-head">
                
                <h1 className="title">BRYT STUDIO</h1>
                <p className="tagline">Games. Apps</p>
                <div className="social-links">
                        <a href="https://www.instagram.com/brytstudio/" target="_blank"rel="noopener noreferrer" className="social-link">
                                <img src="/images/ig.png" alt="instagram" className="social-icon"/>
                        </a>
                        <a href="https://twitter.com/KapyaBright" target="_blank"rel="noopener noreferrer" className="social-link">
                                <img src="/images/twitter.png" alt="instagram" className="social-icon"/>
                        </a>
                        <a href="https://web.facebook.com/BrytStudio/" target="_blank"rel="noopener noreferrer" className="social-link">
                                <img src="/images/fb.png" alt="instagram" className="social-icon"/>
                        </a>
                </div>            
        </div>

)

export default SiteHead
